function HotelBudget() {
    return (
      <>
        <div className="font-bold text-lg mb-16">HotelBudget</div>
      </>
    );
  }
  
  export default HotelBudget;